module.exports = __webpack_public_path__ + "static/media/FortuneofGiza.c3e22824.png";